import { useEffect } from "react"
import isNotEmpty from "@onestore/hel/dist/utils/isNotEmpty"
import type { GenesysChatType } from "~/hooks/useGenesysChatQuery"
import log from "~/lib/log"

const GenesysChat = ({
  domainName,
  environmentName,
  deploymentId,
}: GenesysChatType): null => {
  useEffect(() => {
    if (!isNotEmpty(deploymentId)) {
      return
    }

    const widget = document.getElementById("genesys-messenger")

    if (isNotEmpty(widget)) {
      widget.style.display = "block"
    } else {
      log(`Setting up chat with deploymentId: ${deploymentId}`, "GenesysChat")

      const cmpVendor = process.env.GATSBY_GENESYS_CHAT_CMP_VENDOR

      const script = document.createElement("script")

      script.async = true
      script.type = "text/javascript"

      if (cmpVendor) {
        script.setAttribute("class", "cmplazyload")
        script.setAttribute("data-cmp-vendor", cmpVendor)
        script.setAttribute("data-cmp-purpose", "c51")
      }

      script.innerHTML = `(function (g, e, n, es, ys) {
              g['_genesysJs'] = e;
              g[e] = g[e] || function ()
          
          {       (g[e].q = g[e].q || []).push(arguments)     }
          ;
              g[e].t = 1 * new Date();
              g[e].c = es;
              ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);
            })(window, 'Genesys', 'https://apps.${domainName}/genesys-bootstrap/genesys.min.js',
          
          {     environment: '${environmentName}',     deploymentId: '${deploymentId}'   }
          );`

      document.head.append(script)

      const intervalId = setInterval(() => {
        const wrapperElement = document.getElementById("genesys-messenger")

        if (wrapperElement) {
          wrapperElement.setAttribute("role", "region")
          wrapperElement.setAttribute("aria-label", "Chat")
          wrapperElement.setAttribute("tabindex", "0")
          clearInterval(intervalId)
        }
      }, 100)
    }

    return () => {
      log(`Hiding chat with deploymentId: ${deploymentId}`, "GenesysChat")

      const widget = document.getElementById("genesys-messenger")

      if (isNotEmpty(widget)) {
        widget.style.display = "none"
      }
    }
  }, [domainName, environmentName, deploymentId])

  return null
}

export default GenesysChat
